import {VideoPlayType} from '../type/VIdeoPlayType.enum';
import {isMatchModelAndOs} from './isMatchModelAndOs';

export function getVideoPlayType({
  userAgentStr,
  isWebView,
}: {
  userAgentStr: string;
  isWebView: boolean;
}) {
  // 어떤 이유로 인해 항상 앱 네이티브 플레이어를 띄워야 하는 경우. 지금은 IOS 저전력모드인 경우가 있다.
  if (window?.KNApp?.getIsShouldUseNativeVideoPlayer) {
    const isShouldUseNativePlayer = JSON.parse(
      window.KNApp.getIsShouldUseNativeVideoPlayer()
    );
    if (
      typeof isShouldUseNativePlayer === 'boolean' &&
      isShouldUseNativePlayer
    ) {
      return VideoPlayType.App;
    }
  }
  // TODO: 피쳐 추가
  // 비디오를 앱에서 실행시켜주는 기기 목록 "기기/os,기기/os" 형태의 string으로 되어 있다.
  const playVideoAtAppListStr = ',';
  // getFeature().variable.katalkNovelUsingAppVideoPlayerDevices;

  // TODO:피쳐 추가
  // 비디오를 아예 지원하지 않는 기기 목록 "기기/os,기기/os" 형태의 string으로 되어 있다.
  const notSupportVideoListStr = ',';
  // getFeature().variable.katalkNovelNotSupportVideoDevices;

  // 혹시나 userAgent값을 가져올 수 없으면 동영상 미지원 기기인지 확인이 불가능하므로 동영상을 웹에서 보여준다.
  // 웹뷰가 아닌 경우는 웹으로 판단해서 항상 웹 동영상을 보여준다.
  if (!userAgentStr || !isWebView) {
    return VideoPlayType.Web;
  }
  if (notSupportVideoListStr) {
    const notSupportVideoList = notSupportVideoListStr.split(',');
    if (isMatchModelAndOs(userAgentStr, notSupportVideoList)) {
      return VideoPlayType.None;
    }
  }
  if (playVideoAtAppListStr) {
    const playVideoAtAppList = playVideoAtAppListStr.split(',');
    if (isMatchModelAndOs(userAgentStr, playVideoAtAppList)) {
      return VideoPlayType.App;
    }
  }
  return VideoPlayType.Web;
}
